<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      solo
      slot="activator"
      :label="label"
      :value="formattedDate"
      :disabled="disabled"
      :loading="loading"
      :error-messages="errorMessages"
      :error-count="errorCount"
      :error="error"
      :hide-details="hideDetails"
      :append-icon="appendIcon"
      :prepend-icon="prependIcon"
      readonly
    />
    <v-date-picker
      ref="picker"
      v-model="dateComputed"
      :min="'1900-01-01'"
      :max="new Date().toJSON()"
      @change="save"
    />
  </v-menu>
</template>

<script>
const DEFAULT_DATE_FORMAT = 'YYYY/MM/DD';

export default {
  name: 'DobPicker',
  data: () => ({
    menu: false,
    value: null,
  }),
  model: {
    prop: 'date',
    event: 'input',
  },
  props: {
    date: {
      type: [Date, String],
      default: null,
    },
    min: {
      type: [Date, String],
      default: null,
    },
    max: {
      type: [Date, String],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 290,
    },
    format: {
      type: String,
      default: 'DD-MM-YYYY',
    },
    locale: {
      type: String,
      default: 'en-us',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [String, Array],
      default: () => [],
    },
    errorCount: {
      type: [Number, String],
      default: 1,
    },
    error: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    appendIcon: {
      type: String,
    },
    prependIcon: {
      type: String,
    },
  },
  watch: {
    menu(value) {
      value && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  computed: {
    dateComputed: {
      get() {
        let val = this.selectedDate ? this.$moment(this.selectedDate).format(DEFAULT_DATE_FORMAT) : '';
        return val;
      },
      set(val) {
        let date = this.$moment(val, DEFAULT_DATE_FORMAT);
        let input = this.$moment().year(date.year()).month(date.month()).date(date.date());
        this.selectedDate = input.toDate();
        this.$emit('input', this.selectedDate);
      },
    },
    formattedDate() {
      return this.date ? this.$moment(this.date).format(this.format) : '';
    },
  },
  methods: {
    save(date) {
      this.$refs.menu.save(date)
    }
  },
};
</script>
